import * as React from 'react';
import { Button, Container } from 'semantic-ui-react';
import { autobind } from 'core-decorators';
import { DATA_TEST_ID } from '../data-test-id';
import { Header } from '../header';
import './success-page.less';
import { ExternalIncidentsApi, FileApi, IExternalIncidentParams, SETTINGS } from '@logicmanager/common';

export interface ISuccessPageProps {
    history?: any;
    title?: string;
    message?: string;
    reloadButtonText?: string;
}

interface ISuccessPageState {
    readonly logoUrl: string;
}

export class SuccessPage extends React.Component<ISuccessPageProps, ISuccessPageState> {
    public static defaultProps: Partial<ISuccessPageProps> = {
        title: 'Web Form Title',
        message: 'Thank you for your submission!',
        reloadButtonText: 'Reload the Form'
    };
    constructor(props: ISuccessPageProps) {
        super(props);
        this.state = {
            logoUrl: null
        };
    }

    @autobind
    public handleGoBack(): void {
        this.props.history.go(-1);
    }

    public componentDidMount(): void {
        this.getLogo();
    }

    public componentWillUnmount(): void {
        URL.revokeObjectURL(this.state.logoUrl);
    }

    @autobind
    public parseQueryString(queryString: string): IExternalIncidentParams {
        if (!queryString) {
            return null;
        }
        const paramArray: string[] = queryString.replace('?', '').split('&');
        const params: any = {};
        for (let i: number = 0; i < paramArray.length; i++) {
            const key: string = paramArray[i].split('=')[0];
            const value: string = paramArray[i].split('=')[1];
            params[key] = value;
        }
        return {
            test: params.t,
            plan: params.p,
            key: params.k
        };
    }

    @autobind
    public async getLogo(): Promise<void> {
        const settings: any =
            await ExternalIncidentsApi.getSettings(this.parseQueryString(this.props.history.location.search)).request();
        let logoUrl: string = '';
        if (settings[SETTINGS.USE_HEADER_LOGO] === '1') {
            await FileApi.getHeaderLogo().then((data: Blob) => {
                logoUrl = URL.createObjectURL(data);
            });
        }
        this.setState({logoUrl});
    }

    public render(): JSX.Element {
        return (
            <div data-component="success-page" data-test-id={DATA_TEST_ID.SUCCESS_PAGE}>
                <Header logoUrl={this.state.logoUrl} />
                <Container>
                    <h3>{this.props.history.location.text ? this.props.history.location.text : this.props.message}</h3>
                    <Button
                        className="reload-btn"
                        size="large"
                        primary
                        fluid
                        onClick={this.handleGoBack}
                    >
                        {this.props.reloadButtonText}
                    </Button>
                </Container>
            </div>
        );
    }
}
